'use client';

import { c as _c } from "react/compiler-runtime";
import { CloseButton, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { LoginModalForm } from '@src/components/LoginModal/LoginModalForm';
import { ModalBackdrop } from '@src/components/Modal/ModalBackdrop';
import { cn } from '@src/utils/tailwind';
interface LoginModalProps {
  heading?: string;
  subHeading?: string;
  disclaimer?: string;
  isOpen: boolean;
  onClose: () => void;
  redirectUrl?: string;
}
export const LoginModal = props => {
  const $ = _c(22);
  const {
    heading,
    subHeading,
    disclaimer,
    isOpen,
    onClose,
    redirectUrl
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ModalBackdrop className="backdrop-blur-sm" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("relative mx-auto h-full overflow-hidden bg-white shadow-md transition-all lg:h-auto lg:rounded-3xl", "w-full p-6 pb-14 lg:max-w-[520px] lg:p-16", "data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-150 data-enter:ease-out data-leave:duration-150 data-leave:ease-in data-closed:lg:translate-y-0 data-closed:lg:scale-95");
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CloseButton className={cn("absolute top-4 right-4 flex items-center justify-center rounded-full p-1 text-bodi-black-text transition-all hover:bg-gray-100")}><XMarkIcon className="size-6 stroke-[2px]" /></CloseButton>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== heading) {
    t3 = <DialogTitle className="text-heading-display-3 w-full lg:text-center">{heading}</DialogTitle>;
    $[3] = heading;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== subHeading) {
    t4 = <div className="mb-12 w-full text-body-base lg:mb-0 lg:text-center">{subHeading}</div>;
    $[5] = subHeading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isOpen || $[8] !== onClose || $[9] !== redirectUrl) {
    t5 = <LoginModalForm onClose={onClose} isOpen={isOpen} redirectUrl={redirectUrl} />;
    $[7] = isOpen;
    $[8] = onClose;
    $[9] = redirectUrl;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = disclaimer ?? "";
  let t7;
  if ($[11] !== t6) {
    t7 = <div className="text-center text-body-base [&_a]:underline" dangerouslySetInnerHTML={{
      __html: t6
    }} />;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t7) {
    t8 = <div className="fixed inset-0 flex items-center overflow-y-auto lg:p-2"><DialogPanel transition={true} className={t1}>{t2}<div className="mx-auto mt-12 flex flex-col items-center justify-center gap-4 text-left lg:mt-0 lg:max-w-[390px]">{t3}{t4}{t5}{t7}</div></DialogPanel></div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isOpen || $[19] !== onClose || $[20] !== t8) {
    t9 = <Dialog transition={true} open={isOpen} onClose={onClose} as="div" className="relative z-1000">{t0}{t8}</Dialog>;
    $[18] = isOpen;
    $[19] = onClose;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
};